import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    custom: [],
    list: [],
};

const abSlice = createSlice({
    name: "pkzab",
    initialState,
    reducers: {
        fillAB(state, action) {
            state.custom = action.payload.custom;
            state.list = action.payload.list;
        }
    }
})

export const { fillAB, fuseAB } = abSlice.actions;
export default abSlice.reducer;